import { useEffect, useState } from 'react';

import { FormInstance, Typography } from 'antd';

import { ColSize, RowSize } from '../../../../../../../shared/components';
import { CoverageCard } from './components';

import { CoveragePerPlan } from '../../../../../../../shared/interfaces';

import { generateInputID } from '../../../AP/Steps/StepThree/components/Quotation/utils';
import { GroupedCoveragesCardsResult } from '../../../utils';
import { QuotationInfo } from '../../interfaces';

interface GroupedCoverageCardsListProps {
  allCoveragesByTabList: Array<CoveragePerPlan>;
  quotationInfo: QuotationInfo | undefined;
  getRelationWithOtherCoverage: (
    id: string,
    allCoveragesByTabList: Array<CoveragePerPlan>,
  ) => { codigoCoberturaRelacionada: string; codigoRiesgo: string } | undefined;
  groupedCoverageKey: string;
  groupedCoveragesCardsResult: GroupedCoveragesCardsResult;
  tabKeyForm: string;
  usedFormToCoverageCard: FormInstance<any>;
  className?: string;
}

export const GroupedCoverageCardsList = ({
  allCoveragesByTabList,
  quotationInfo,
  getRelationWithOtherCoverage,
  groupedCoverageKey,
  groupedCoveragesCardsResult,
  tabKeyForm,
  usedFormToCoverageCard,
  className,
}: GroupedCoverageCardsListProps) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
      {
        groupedCoveragesCardsResult[groupedCoverageKey].title?.length || !className?.includes('grouped-coverages-first-title')
          ? (
            <RowSize className={className}>
              <ColSize size={100}>
                <Typography.Title level={5} style={{ margin: 0, paddingBottom: 8 }}>
                  {groupedCoveragesCardsResult[groupedCoverageKey].title}
                </Typography.Title>
              </ColSize>
            </RowSize>
          )
          : <></>
      }
      <RowSize rowProps={{ gutter: [0, 0] }}>
        {groupedCoveragesCardsResult[groupedCoverageKey].list.map(
          (coverage: CoveragePerPlan, index: number) => (
            <ColSize
              className={`mb-1 ${
                index % 2 === 0 && windowWidth > 767 ? 'pr-1' : ''
              }`}
              size={50}
              key={`${coverage.codigo}-${index}`}
            >
              <CoverageCard
              quotationInfo={quotationInfo}
                activitiesForm={usedFormToCoverageCard}
                activityKey={tabKeyForm}
                checkboxName={generateInputID(
                  coverage.id,
                  tabKeyForm,
                  'checkbox'
                )}
                coverage={coverage}
                coveragesList={allCoveragesByTabList}
                primaInputName={generateInputID(
                  coverage.id,
                  tabKeyForm,
                  'prima'
                )}
                relationWithOtherCoverage={getRelationWithOtherCoverage(
                  coverage.id,
                  allCoveragesByTabList
                )}
                sumaAseguradaInputName={generateInputID(
                  coverage.id,
                  tabKeyForm
                )}
              />
            </ColSize>
          )
        )}
      </RowSize>
    </>
  );
};
